import { render } from "./PayoutBody.vue?vue&type=template&id=6ec131f0"
import script from "./PayoutBody.vue?vue&type=script&lang=js"
export * from "./PayoutBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__